export function setPageMeta({ title, description, image, url }) {
  document.title = title

  const setMeta = (attr, key, content) => {
    let el = document.querySelector(`meta[${attr}="${key}"]`)
    if (!el) {
      el = document.createElement('meta')
      el.setAttribute(attr, key)
      document.head.appendChild(el)
    }
    el.setAttribute('content', content)
  }

  setMeta('property', 'og:title', title)
  setMeta('property', 'og:description', description)
  setMeta('property', 'og:image', image)
  setMeta('property', 'og:url', url)
  setMeta('name', 'twitter:title', title)
  setMeta('name', 'twitter:description', description)
  setMeta('name', 'twitter:image', image)

  let canonical = document.querySelector('link[rel="canonical"]')
  if (!canonical) {
    canonical = document.createElement('link')
    canonical.setAttribute('rel', 'canonical')
    document.head.appendChild(canonical)
  }
  canonical.setAttribute('href', url)
}

export function stripHtmlTags(html) {
  if (!html || typeof html !== 'string') return '';

  // 1. Remove script, style, and comment blocks entirely (content included)
  let clean = html.replace(/<(script|style|svg|xml)[^>]*>[\s\S]*?<\/\1>/gi, '');
  clean = clean.replace(/<!--[\s\S]*?-->/g, '');

  // 2. Decode standard HTML entities before/after stripping tags
  clean = clean
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'");

  // 3. Remove all remaining HTML tags
  clean = clean.replace(/<[^>]+>/g, '');

  // 4. Normalize multiple whitespace and line breaks
  return clean.replace(/\s+/g, ' ').trim();
}